export enum BannerDisplayWeekEnum {
  All,
  Weekdays,
  Weekends,
}
